// extracted by mini-css-extract-plugin
export default {"Container":"vision_Container__yRHP1","DarkEffect":"vision_DarkEffect__7c6W2","Background":"vision_Background__mNIza"};